import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Permission Group setting'
  }
];

@Component({
  selector: 'page-permission',
  templateUrl: './permission.html',
  styleUrls: ['./permission.scss']
})

export class PagePermission implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  cksearch:boolean=false;
  form: FormGroup;

  approve_items=[];
  approve_levels=[];
  users = [];
  rows = [];
  temp=[];
  lines=[];

  key:any="";

  data:any;

  loadingIndicator: boolean = true;
  id:string;
  ckedit:boolean=false;
  picture:String;
  //upload file
  imageSrc:any;

  Name:string; 
  myFile:File; /* property of File type */
  dialogRefWarning: MdDialogRef<WarningPmDialog>;
  dialogRef: MdDialogRef<pmDialog>;
  setId:any;
  sysPath:String=environment.sysPath;
  sysPathPrint:String=environment.sysPath+"/api/approve-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/approve-list-export.php";


  dropdownListPermission = [];
  selectedItemsPermission = [];

  //dropdownSettings = {};
  dropdownSettings = { 
    singleSelection: false, 
    text:"Select",
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    classes:"col-md-12"
  };  


  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
  this.getPermission();
  this.getStartData();
    this._sharedService.emitChange(this.pageTitle);
  }

onItemSelect(item:any){}
OnItemDeSelect(item:any){}
onSelectAll(items: any){}
onDeSelectAll(items: any){}

  intervalGetData(){
    return setInterval(() => {
      if(this.setId.runCount>5){
      clearInterval(this.setId);
      }
      this.getStartData();
      console.log('------this.setId------',this.setId.runCount);
     }, 1000);
  }



  getPermission(){
    this.httpservice.fetchget('getJSON_menu.php?type=2',(data)=>{
     // this.products = data;
     console.log('menu',data);
      for(let i = 0;i<data.length;i++){
        this.dropdownListPermission.push({"id":data[i].tb129f_id,"itemName":data[i].tb129f_name});
      }
    });
  }

  getStartData(){

    this.httpservice.fetchget('getJSON_group_permission.php?',(data) => {
      this.rows = data;
      this.temp = data;
      this.loadingIndicator = false;
      console.log('------this.cksearch------',this.cksearch);
    });
  }

  delete(id:string){
  let val = {id:id}
  this.httpservice.fetchpost('deletePermissionGroup.php', val, (cb) => {});
  this.getStartData();
  }

  setedit(id:string){
    this.cancelEdit();
    this.id = id;
    this.ckedit=true;
    this.httpservice.fetchget('getJSON_group_permission.php?id='+id,(data) => {
      let tb130f_id:any;
      this.form.controls.groupName.setValue(data[0].tb130f_name);
      tb130f_id = data[0].tb130f_id;
      this.selectedItemsPermission = data[0].items;
      console.log();
    });
  }

  edit(){
    this.setId = this.intervalGetData();
    this.ckedit = false;
    this.data = {
      id:this.id,
      name:this.form.controls.groupName.value,
      items:this.selectedItemsPermission
    }
    // insert data
    this.httpservice.fetchpost('editPermissionGroup.php', this.data, (cb) => {
    //upload document
    this.getStartData();
    this.cancelEdit();
    });

  }

  cancelEdit(){
    this.ckedit = false;
    this.form.reset();
    this.selectedItemsPermission = [];

  }


save(){
  this.setId = this.intervalGetData();
  this.data = {
    name:this.form.controls.groupName.value,
    items:this.selectedItemsPermission
  }
  // insert data
  this.httpservice.fetchpost('insertGroupPermission.php', this.data, (cb) => {
  this.getStartData();
  this.cancelEdit();
  });

}

search(){

  }

  ngOnInit() {
    this.form = this.fb.group({
        secret_code: [null, Validators.compose([Validators.required])],
        fileInput: [null, Validators.compose([Validators.required])],
        groupName: [null, Validators.compose([Validators.required])]
    });

  }

  attachFile(event) : void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function(e) {
      _self.imageSrc = reader.result;
      console.log(_self.imageSrc);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile = event.target.files[0];
   //this.uploadPhoto(event.target.files[0]);
   console.log('File name : ',this.myFile.name);
   }


    updateFilter_item(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.tb130f_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }




  openDeleteDialog(id:string) {

    let dialogRef = this.dialog.open(pmDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to delete this?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
          this.delete(id);
        console.log('---result---',result,id);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openEditDialog(){
    let dialogRef = this.dialog.open(pmDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.groupName.value !=null && this.selectedItemsPermission.length>0){
          this.edit();
        }else{
          this.warningDialog('Please fill in group name, menu item');
        }
      
       // console.log('---result---',result,this.user_selected.value.length,this.form.controls.code.value,this.form.controls.name.value,this.form.controls.ct.value);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openDialog(){
    let dialogRef = this.dialog.open(pmDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.groupName !=null && this.selectedItemsPermission.length>0){
          this.save();
        }else{
          this.warningDialog('Please fill in Group Name, sellect menu items');
        }
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }

  warningDialog(message: string) {

    let dialogRef = this.dialog.open(WarningPmDialog);
    let instance = dialogRef.componentInstance;
    instance.message = message;
    instance.title = "Warning";

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;

      if (result === '1') {

        // alert('postString');
      } else {
        console.log('---result---', result);
        // alert('cancel');
      }

    });
  }
}
//dialog
@Component({
  selector: 'pm-dialog',
  templateUrl: 'dialog.html',
})
export class pmDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<pmDialog>) {}
}

//warning
@Component({
  selector: 'warning-pm-dialog',
  templateUrl: 'warning.html',
})
export class WarningPmDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningPmDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/permission/permission.ts